import { render } from "react-dom";
import PlayVideo from "../helpers/PlayVideo";
import favorites from "../helpers/favorites";

export default function () {
	if (typeof Cookies.get("games_played_count") !== "undefined") {
		if (Cookies.get("games_played_count") <= gameMinPlayedToPreroll) {
			console.log("No Mostrar Ad");
			preroll = false;
		}
	}

	// Gestion favoritos

	window.updateFavorites = true;
	".js-addtofavorite".on("click", favorites.toggler);
	favorites.buttonCheck("#add_favorite");

	new PlayVideo();
}
